<mat-tab-group>
    <mat-tab label="Profilo professionale">
        <div class="container" *ngIf="datiProfilo">
            <h1>{{datiProfilo.codiceProfilo}} - {{datiProfilo.nomeProfilo}}</h1>
            <div class="margin-bottom-20" *ngIf="datiProfilo.descrizioneProfilo">
                <p><strong>Descrizione profilo professionale</strong></p>
                <p>{{datiProfilo.descrizioneProfilo}}</p>
            </div>
            <div class="margin-bottom-20" *ngIf="datiProfilo.elementiContesto">
                <p><strong>Elementi di contesto</strong></p>
                <p>{{datiProfilo.elementiContesto}}</p>
            </div>
            <p class="margin-bottom-20" *ngIf="datiProfilo.livelloEqf"><strong>Livello EQF:
                    {{datiProfilo.livelloEqf}}</strong></p>

            <h1>Classificazioni</h1>
            <div *ngIf="classificazioniAda" class="margin-bottom-20">
                <p class="width-100">
                    <strong>ADA:</strong>
                </p>
                <mat-list>
                    <mat-list-item *ngFor="let item of classificazioniAda">
                        <strong>{{item.codiceAda}}</strong> - {{item.descrizione}}
                    </mat-list-item>
                </mat-list>
            </div>
            <div *ngIf="classificazioniIstat" class="margin-bottom-20">
                <p class="width-100">
                    <strong>Classificazione Nazionale delle Professioni ISTAT</strong>
                </p>
                <mat-list>
                    <mat-list-item *ngFor="let item of classificazioniIstat">
                        <strong>{{item.codiceIstat}}</strong> - {{item.descrizione}}
                    </mat-list-item>
                </mat-list>
            </div>
            <div *ngIf="classificazioniAteco" class="margin-bottom-20">
                <p class="width-100">
                    <strong>Classificazione Nazionale delle Attività economiche ATECO</strong>
                </p>
                <mat-list>
                    <mat-list-item *ngFor="let item of classificazioniAteco">
                        <strong>{{item.codiceAteco}}</strong> - {{item.descrizione}}
                    </mat-list-item>
                </mat-list>
            </div>
            <div *ngIf="classificazioniIsco" class="margin-bottom-20">
                <p class="width-100">
                    <strong>Classificazione Internazionale delle Professioni ISCO</strong>
                </p>
                <mat-list>
                    <mat-list-item *ngFor="let item of classificazioniIsco">
                        <strong>{{item.codiceIsco}}</strong> - {{item.descrizione}}
                    </mat-list-item>
                </mat-list>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Competenze di profilo">
        <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSource">

                <!-- Position Column -->
                <ng-container matColumnDef="competenza">
                    <th mat-header-cell *matHeaderCellDef> Competenza di profilo </th>
                    <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="eqf">
                    <th mat-header-cell *matHeaderCellDef> Livello EQF </th>
                    <td mat-cell *matCellDef="let element"> {{element.eqfCompetenza}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="azioni">
                    <th mat-header-cell *matHeaderCellDef> Azioni </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon class="green" (click)="openDettaglioCompetenza(element)"
                            matTooltip="Visualizzazione delle Abilità e delle Conoscenze">search</mat-icon>
                        <!--mat-icon class="green" (click)="downloadProposta(element)" matTooltip="Scarica PDF Competenza">insert_drive_file</mat-icon -->
                    </td>
                </ng-container>



                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSize]="10" showFirstLastButtons [length]="paginatorSize"
                aria-label="Select page of periodic elements">
            </mat-paginator>
        </div>
    </mat-tab>
</mat-tab-group>


<style>
    ::ng-deep .mdc-list-item .mdc-list-item__primary-text {
        color: #333 !important;
    }

    .green {
        color: #008047;
        margin: 0 2px;
        cursor: pointer;
    }

    .width-100 {
        display: block;
        width: 100%;
        border-bottom: 1px solid #008047;
    }

    ::ng-deep .mdc-list-item:nth-child(odd) {
        background-color: #eee !important;
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .container {
        padding: 15px;
    }

    .fixed-width {
        min-width: 40%;
        display: block;
        float: left;
        margin-left: 10px
    }

    .left {
        float: left;
    }

    .divider {
        color: #91CB6C;
        height: 3px;
        margin-bottom: 40px;
        margin-top: 20px;
        background-color: #91CB6C;
        width: 100%;
    }

    .custom-input {
        padding-right: 10%;
        width: 90%
    }

    .input-icon {
        position: absolute;
        right: 1%;
        bottom: 27%;
        color: #008047;
        border: 1px solid #008047;
        border-radius: 50%;
        cursor: pointer;
    }

    .input-icon.external {
        margin-right: -12%;
        bottom: 45%;
    }

    .cancel-icon {
        color: #800020;
        position: relative;
        top: 6px;
        left: 15px;
        cursor: pointer;
    }

    .full-width {
        width: 100%;
        /* padding-right: 30px; */
    }

    div.full-width {
        height: auto;
        overflow: auto;
    }

    strong {
        color: #008047;
        text-transform: uppercase;
        /* width: 185px; */
        /* float: left; */
        /* display: block; */
    }

    .decreto {
        margin: 5px 0;
        list-style-type: none;
        text-transform: uppercase;
        cursor: pointer;
        color: #008047;
        overflow: auto;
        clear: both;
        display: block;
    }

    .decreto mat-icon {
        float: left;
        margin-right: 20px;
    }

    .decreto mat-icon {
        float: left;
        margin-right: 20px;
    }

    .decreto span {
        height: 24px;
        line-height: 24px;
        display: block;
        float: left;
    }

    .actions {
        right: 5px;
        bottom: 10px;
        position: sticky !important;
        justify-content: end;
    }

    .ripristina-button {
        background-color: #800020;
        color: #fff;
        cursor: pointer;
    }


    .save-button {
        margin-left: 20px;
        background-color: #008047;
        color: #fff;
        margin-right: 4%;
    }

    .save-button:disabled {
        margin-left: 20px;
        background-color: #eee;
        color: #ccc;
        /* cursor: pointer; */
    }

    ::ng-deep .mat-mdc-button:not(:disabled) {
        color: #fff !important;
        background-color: #056339;
    }

    ::ng-deep .mat-mdc-button:disabled {
        color: #ccc !important;
        background-color: #eee;
    }

    ::ng-deep .cdk-overlay-dark-backdrop {
        background: rgba(0, 0, 0, .72);
    }

    ::ng-deep .mat-mdc-select {
        color: #333;
    }

    h1 {
        background-color: #056339;
        text-align: center;
        color: #fff;
    }

    ::ng-deep .mdc-list-item__primary-text .grey {
        color: #333 !important;
    }




    ::ng-deep .mdc-list-item__primary-text .numeric-list-item {
        color: #333 !important;
        font-size: 14px;
    }

    ::ng-deep .mdc-list-item.mdc-list-item--with-one-line.elenco-list {
        height: 20px;
    }

    /* ::ng-deep .mdc-list-item.mdc-list-item--with-one-line {
        height: auto !important;
    } */

    ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
        background-color: #fff;
        border-radius: 10px;
        /* border: 5px solid #056339; */
    }

    ::ng-deep .mdc-text-field--filled.mdc-text-field--disabled {
        background-color: #eee;
        border: 1px solid #ccc;
        color: #333;
    }

    ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
        background-color: #fff;
        border: 1px solid #ccc;
    }


    ::ng-deep .mdc-text-field.mdc-text-field--disabled .mdc-floating-label {
        color: #333;
    }

    ::ng-deep .mdc-text-field:not(.mdc-text-field--disabled) .mdc-floating-label {
        color: #056339;
    }

    ::ng-deep .mdc-text-field {
        border-radius: 5px !important;
    }

    ::ng-deep .mdc-text-field .mdc-text-field__input {
        caret-color: #333 !important;
    }

    ::ng-deep .mdc-text-field.mdc-text-field--disabled .mdc-text-field__input {
        color: #333;
    }

    ::ng-deep .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input {
        color: #333;
    }

    ::ng-deep .mdc-text-field--filled .mdc-line-ripple::after {
        border-bottom-color: #91CB6C;
    }

    ::ng-deep .mat-mdc-select-arrow,
    ::ng-deep .mat-mdc-select-arrow:focus,
    ::ng-deep .mat-mdc-select-arrow::selection {
        color: #333 !important;
    }

    .close-icon {
        position: absolute;
        top: 20px;
        right: 10px;
        cursor: pointer;
    }

    .details-form {
        padding: 2%;
    }

    .half-width,
    .half-width-textarea {
        width: 48%;
        float: left;
    }

    .half-width.icon-right {
        width: 42%;
        position: relative;
    }

    .half-width:first-child {
        margin-right: 4%;
    }

    .full-width-textarea {
        width: 100%;
        /* padding-right: 30px; */
    }

    .margin-right {
        margin-right: 4%;
    }

    textarea {
        resize: none;
        height: 200px;
    }

    .form-container {
        display: block;
        min-height: 500px;
    }

    .legend {
        display: block;
        width: 46%;
        padding: 10px 10px 10px 25px;
        left: 0;
        bottom: 10px;
        color: #fff;
        position: absolute;
        font-size: 11px;

    }

    p {
        color: #333;

    }


    p strong {
        color: #000;
        font-weight: bold;
    }

    ul {
        margin-left: 20px;
        padding-left: 0;
        list-style-type: disc;
        color: #056339;
    }

    .legend li {
        height: 13px;
    }

    ::ng-deep .mat-datepicker-content .mat-calendar {
        width: 296px;
        height: 354px;
        background-color: #fff !important;
    }

    ::ng-deep .mat-datepicker-content .mat-calendar button,
    ::ng-deep .mat-datepicker-content .mat-calendar span {
        color: #008047 !important;
    }

    ::ng-deep .mat-datepicker-content .mat-calendar .mat-calendar-header {
        background-color: #008047 !important;
    }

    /* ::ng-deep .mat-datepicker-content .mat-calendar button,
    ::ng-deep .mat-datepicker-content .mat-calendar span {
        color: #fff !important;
    } */


    ::ng-deep .mat-datepicker-content .mat-calendar span.mat-calendar-body-selected,
    ::ng-deep .mat-datepicker-content .mat-calendar span:hover {
        background-color: #91cb6c !important;
    }

    ::ng-deep .mat-datepicker-content .mat-calendar span.mat-calendar-body-today {
        background-color: none !important;
    }

    .mat-mdc-table {
        background: #fff !important;
    }

    .mat-mdc-table .mdc-data-table__row:nth-child(odd) {
        background-color: #eee;
    }


    .mat-mdc-table .mat-mdc-header-cell {
        /* background-color: #056339 !important; */
        color: #056339;
        text-transform: uppercase;
        border-bottom: 1px solid #056339 !important;
    }

    .mat-mdc-table .mat-mdc-cell {
        /* background-color: #fff !important; */
        color: #333;
        font-size: 12px;
        padding: 3px 0 3px 12px;
    }
</style>